import Store from '@ember-data/store';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import type { SelectOption } from 'donor-elf-web/lib/form-component-utils';
import AdminRoleModel from 'donor-elf-web/models/admin/role';
import type { AdminUserAddRouteModel } from 'donor-elf-web/routes/admin/users/add';

export default class AdminUserAddNameController extends Controller {
  model!: AdminUserAddRouteModel;

  @service declare router: RouterService;
  @service declare store: Store;

  @tracked saving = false;
  @tracked showValidationErrors = false;

  get roleOptions(): SelectOption[] {
    return sortByProperties<AdminRoleModel>(this.model.roles, ['name']).map(
      (x) => {
        return {
          val: x.name,
          label: x.name,
        };
      },
    );
  }

  get hasNextStep() {
    return this.model.changeset.get('role') !== 'Org-Admin';
  }

  @action
  templateWillDestroy() {
    this.saving = false;
    this.showValidationErrors = false;
  }

  @action
  async save() {
    this.saving = true;
    let { changeset } = this.model;
    await changeset.validate();
    if (changeset.get('isValid')) {
      let usersWithEmail = await this.store.query('admin/user-email-exist', {
        filter: { email: changeset.get('email') },
      });
      this.saving = false;
      if (usersWithEmail.length === 0) {
        this.router.transitionTo('admin.users.add.referred-by');
      } else {
        changeset.pushErrors(
          'email',
          'Email already taken by a user with another organization',
        );
        this.showValidationErrors = true;
      }
    } else {
      this.saving = false;
      this.showValidationErrors = true;
    }
  }
}
